import type {
  TravelTypeParameter,
  ClientIDParameter,
} from '@/api/hotelContentApi';
import type {Portal} from '@/types';
import type {TravelType} from '@travel-frontend/ui-components';

const travelTypeMapping: Record<TravelType, TravelTypeParameter> = {
  packageTour: 'P',
  ownArrival: 'H',
  holidayHomes: 'U',
};

export const mapTravelType = (travelType: TravelType): TravelTypeParameter => {
  return travelTypeMapping[travelType];
};

const clientIdMapping: Record<Portal, ClientIDParameter> = {
  'aidu-de': 'AIDU.de',
  'aidu-at': 'AIDU.at',
  'aidu-ch': 'AIDU.ch',
  'invia-cz': 'invia.cz',
  'invia-sk': 'invia.sk',
  'invia-hu': 'invia.hu',
  'travelplanet-pl': 'travelplanet.pl',
  'reisegeier-at': 'reisegeier.at',
  'reisegeier-ch': 'reisegeier.ch',
  'reisegeier-de': 'reisegeier.de',
  'reisen-de': 'reisen.de',
  'reisen-fluege-de': 'reisen.fluege.de',
};

export const mapClientId = (portal: Portal): ClientIDParameter => {
  return clientIdMapping[portal];
};
